module.exports = __webpack_public_path__ + "static/media/Yarco Divisional Court Decision.efcb5996.pdf";